import request from '@/utils/request'
/**
 *获取车辆信息
 * @param {*} data
 */
function getCarInfo(data) {
  return request({
    url: '/travelAnalysis/getTripStatistics',
    method: 'post',
    data
  })
}

/**
 * 获取当天行程详情
 * @param {*} data
 */
 function getTripDetails(data) {
  return request({
    url: '/travelAnalysis/getTripDetails',
    method: 'post',
    data
  })
}
/**
 * 导出
 * @param {*} data
 */
function exportCar(data) {
  return request({
    url: '/travelAnalysis/exportTripStatistics',
    method: 'post',
    responseType: 'arraybuffer',
    data
  })
}

export {
  getCarInfo,
  exportCar,
  getTripDetails
}

